var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.13 1.223 5.5 4.472a1 1 0 0 1 .37.778V14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6.473a1 1 0 0 1 .37-.777l5.5-4.473a1 1 0 0 1 1.26 0M13 6.473 7.5 2 2 6.472V14h11z"
  })));
};
export default SvgHome;